<template>
  <div class="page-content">
    <page-template
      class="info-container"
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
    ></page-template>
  </div>
</template>

<script>
import pageTemplate from '@/components/template/pageTemplate';
import api from '@/config/api';
import userPower from '@/mixin/userPower';

export default {
  mixins: [userPower],
  components: {
    pageTemplate

  },
  data() {
    return {
      labelWidth: "150",
      dialogVisibility: false,
      toolConfig: [],
      // 高级搜索条件
      searchOptions: {
        simple: [
          {label: "条码/品名/助记码", prop: "otherName", type: "input", placeholder: '请输入条码/品名/助记码',},
        ],
        complex: [
          {label: "选择日期", prop: "CreateDttm", type: "dateTimeRangeButton", dateType: "datetime", span: 24},
          {label: "门店名称", prop: "storeId", type: "select", isHasAll: true, data: [], url: api.system.seStore},
          {label: "单号", prop: "orderNo", type: "input"},
        ]
      },
      // 表格信息配置
      tableOptions: {
        indexShow: true,//是否显示索引
        columns: [
          {
            label: '单号',
            prop: 'orderNo',
            width: '230',
            align: 'center',
            callback: this.goOrderDetail,
          },
          {label: '门店名称', prop: 'storeName', width: '150', align: 'center'},
          {label: '条码', prop: 'barCode', width: '150', align: 'center'},
          // {label: '自编码', prop: 'artNo', width: '150', align: 'center'},
          {label: '品名', prop: 'goodsName', width: '150', align: 'center'},
          {label: '单位', prop: 'unitName', width: '70', align: 'center'},
          {label: '规格', prop: 'specs', width: '70', align: 'center'},
          {label: '原进货价', prop: 'buyPrice', width: '100', align: 'center'},
          {label: '新进货价', prop: 'paBuyPrice', width: '100', align: 'center'},
          {label: '原零售价', prop: 'retailPrice', width: '100', align: 'center'},
          {label: '新零售价', prop: 'paRetailPrice', width: '100', align: 'center'},
          {label: '原会员价', prop: 'vipPrice', width: '100', align: 'center'},
          {label: '新会员价', prop: 'paVipPrice', width: '100', align: 'center'},
          // {label: '原PLUS会员价', prop: 'plusVipPrice', width: '130', align: 'center'},
          // {label: '新PLUS会员价', prop: 'paPlusVipPrice', width: '130', align: 'center'},
          {label: '原批发价', prop: 'tradePrice', width: '100', align: 'center'},
          {label: '新批发价', prop: 'paTradePrice', width: '100', align: 'center'},
          {label: '原配送价', prop: 'deliveryPrice', width: '100', align: 'center'},
          {label: '新配送价', prop: 'paDeliveryPrice', width: '100', align: 'center'},
          {label: '调价时间', prop: 'lastModifyDttm', width: '150', align: 'center'},
          {label: '备注', prop: 'remarks', width: '100', align: 'center'},
        ],
        url: api.archives.priceDadjapGoods
      },
      // 详情
      detailColumns: {
        statusOption: {
          prop: 'reviewerStatus',
          statusImg: {
            10: '/static/checked.png',
            20: '/static/un-check.png'
          },
          right: '350px',
          top: '30px'
        },
        span: 8,
        labelWidth: "130",
        columns: [
          {
            label: '业务单号',
            prop: 'orderNo',
            span: 12,
          },
          // {
          //   label: '门店',
          //   prop: 'storeId',
          //   url: api.system.seStore,
          //   span: 12,
          // },
          {
            label: '调价类别',
            prop: 'types',
            span: 12,
            enumData: this.$utils.getCacheStatus('asPriceAdjustmentOrder.type')
          }, {
            label: '备注',
            prop: 'remarks',
            span: 12
          },
        ],
        tablesProp: {
          adjustmentGoodsMapList: {
            url: api.archives.priceDadjapGoods + '/detail/page',
            tableName: 'adjustmentGoodsMapList',
            indexShow: true,
            columns: [
              {
                label: '条码',
                prop: 'barCode',
                width: '100',
              },
              {
                label: '商品名称',
                prop: 'goodsName',
                width: '100',
              },
              {
                label: '规格',
                prop: 'specs',
                width: '100'
              },
              {
                label: '单位',
                prop: 'unitName',
                width: '100'
              },
              {
                label: '原进货价',
                prop: 'buyPrice',
                align: 'center',
                width: '110',
              },
              {
                label: '进货价',
                type: 'inputNumber',
                prop: 'paBuyPrice',
                align: 'center',
                width: '110',
              },
              {
                label: '原零售价',
                prop: 'retailPrice',
                align: 'center',
                width: '110',
              },
              {
                label: '零售价',
                type: 'inputNumber',
                prop: 'paRetailPrice',
                align: 'center',
                width: '110',
              },
              {
                label: '原最低零售价',
                prop: 'lowestPrice',
                align: 'center',
                width: '110',
              },
              {
                label: '最低零售价',
                type: 'inputNumber',
                prop: 'paLowestPrice',
                align: 'center',
                width: '110',
              },
              {
                label: '原会员价',
                prop: 'vipPrice',
                align: 'center',
                width: '110',
              },
              {
                label: '会员价',
                type: 'inputNumber',
                prop: 'paVipPrice',
                align: 'center',
                width: '110',
              },
              {
                label: '原PLUS会员价',
                prop: 'plusVipPrice',
                align: 'center',
                width: '110',
              },
              {
                label: 'PLUS会员价',
                type: 'inputNumber',
                prop: 'paPlusVipPrice',
                align: 'center',
                width: '110',
              },
              {
                label: '原批发价',
                prop: 'tradePrice',
                align: 'center',
                width: '110',
              },
              {
                label: '批发价',
                type: 'inputNumber',
                prop: 'paTradePrice',
                align: 'center',
                width: '110',
              },
              {
                label: '原配送价',
                prop: 'deliveryPrice',
                align: 'center',
                width: '110',
              },
              {
                label: '配送价',
                type: 'inputNumber',
                prop: 'paDeliveryPrice',
                align: 'center',
                width: '110',
              },
              {
                label: '备注',
                prop: 'remarks',
                width: '90',
              },
            ],
          }
        },
        url: api.archives.priceDadjap
      }
    };
  },
  created() {
    this.setStore(this.searchOptions.complex);
  },
  methods: {
    goOrderDetail(row) {
      this.$utils.setDataByKey(this.$utils.storeKeys.FORMINFO, this.detailColumns);
      this.$utils.getDataByKey(this.$utils.storeKeys.FORMINFO)
      const {href} = this.$router.resolve({
        name: "pdadjapDetail",
        query: {id: row.adjustmentId},
      });
      window.open(href, "_blank");

    },
  }
};
</script>

<style scoped>
.info-container {
  padding-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/page/archives/query/Dadjap.vue